import { MUTATIONS, useMutation } from "../../../../api";
import { useIsWindowSmall } from "../../../../lib/device-utils.js";
import styles from "../dropdown.css.js";
import { ROUTES } from "../../../../routes.js";
import { DropdownLinksWhenAdmin } from "./DropdownLinksWhenAdmin.jsx";
import { DropdownLink } from "./DropdownLink.jsx";

/**
 * Renders dropdown links available to authenticated users, including links to the dashboard,
 * profile, legal information, and logout functionality. If the user is an admin, additional admin
 * links will be displayed.
 *
 * @param {Object} props - The properties object.
 * @param {Object} props.me - The current authenticated user object.
 * @param {Function} props.close - The function to close the dropdown.
 * @param {string} props.linkHost - The base URL to be used for constructing links.
 * @return {JSX.Element} The JSX element representing the dropdown links.
 */
export function DropdownLinksWhenAuthenticated({
  me,
  close,
  linkHost,
  withLogo,
}) {
  const [doLogout] = useMutation(MUTATIONS.logout);
  const landingpageURL = "https://www.digital-sparks.org";
  const onMobile = useIsWindowSmall();

  return (
    <>
      <p className={styles.loginInfo({ withLogo: withLogo })}>
        Eingeloggt als {me.name}#{me.tag}
      </p>
      {!onMobile && (
        <>
          <DropdownLink
            close={close}
            linkHost={linkHost}
            to={ROUTES.lernreisenOverview.getUrl()}
          >
            Dashboard
          </DropdownLink>
          <DropdownLink close={close} linkHost={linkHost} to="/profile">
            Dein Profil
          </DropdownLink>
        </>
      )}
      <DropdownLink
        close={close}
        linkHost={landingpageURL}
        to="/impressum"
        target="_blank"
      >
        Impressum
      </DropdownLink>
      <DropdownLink
        close={close}
        linkHost={landingpageURL}
        to="/datenschutz"
        target="_blank"
      >
        Datenschutz
      </DropdownLink>
      {me.isAdmin && (
        <DropdownLinksWhenAdmin close={close} linkHost={linkHost} />
      )}
      <DropdownLink
        close={close}
        size="md"
        onClick={() => doLogout()}
        isLast={true}
      >
        Logout
      </DropdownLink>
    </>
  );
}
